import { render } from "./SurveyFinishType.vue?vue&type=template&id=e248d8b4&scoped=true"
import script from "./SurveyFinishType.vue?vue&type=script&lang=js"
export * from "./SurveyFinishType.vue?vue&type=script&lang=js"

import "./SurveyFinishType.vue?vue&type=style&index=0&id=e248d8b4&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e248d8b4"]])

export default __exports__